import ProductCard from './ProductCard';
import Loading from '../common/Loading';
import './ProductList.css';

const ProductList = ({ products, loading, error, title }) => {
  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <div className="error-message">Error: {error}</div>;
  }

  if (!products || products.length === 0) {
    return <div className="no-products">No products found</div>;
  }

  return (
    <div className="product-list">
      {title && <h2 className="product-list-title">{title}</h2>}
      <div className="product-grid">
        {products.map(product => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
};

export default ProductList;
